"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@formily/core");
var context_1 = require("../context");
exports.useFieldState = function (defaultState) {
    var ref = react_1.useRef();
    var field = react_1.useContext(context_1.FieldContext);
    react_1.useMemo(function () {
        field.setState(function (state) {
            Object.assign(state, defaultState);
        });
    }, []);
    ref.current = core_1.isField(field) ? field.getState() : field.getState();
    return [
        ref.current,
        function (nextState) {
            if (!nextState)
                return;
            field.setState(function (state) {
                Object.assign(state, nextState);
            });
        }
    ];
};
